import { useRef, useEffect } from 'react';

// Frill widget key constant
const FRILL_WIDGET_KEY = 'widget_9pHovG_MdhKJ9';

// Type for Frill widget
export interface FrillWidget {
	open: () => void;
	close: () => void;
	destroy: () => void;
	events: Record<string, unknown>;
}

// Extend Window interface to include Frill
declare global {
	interface Window {
		Frill: ( type: string, config: unknown ) => FrillWidget;
	}
}

export function useFrillWidget() {
	const widgetRef = useRef<FrillWidget | null>( null );

	useEffect( () => {
		// Check if Frill is available
		if ( typeof window !== 'undefined' && window.Frill ) {
			// This is an async function, but we're not going to use the resolved result directly,
			// instead we assign the promise to a variable so we can destroy it in the hook cleanup.
			const frillWidget = window.Frill( 'widget', {
				key: FRILL_WIDGET_KEY,
				callbacks: {
					onReady( widgetInstance: FrillWidget ): void {
						widgetRef.current = widgetInstance;
						// You can subscribe to widget events like so, don't forget to unsubscribe though.
						// const unsubscribe = widgetRef.current.events.on('badgeCount', console.log)
					}
				}
			} );

			return () => {
				widgetRef.current = null;
				// Calling destroy will also remove the widget from the DOM
				frillWidget.destroy();
			};
		}
		return undefined;
	}, [] );

	return widgetRef;
}
